import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { addDays, AP_MONTHS } from 'lib/DateTime';

class WaffleBadge extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    index: PropTypes.number,
    cardsLength: PropTypes.number,
    metadata: PropTypes.objectOf(PropTypes.string),
  };

  static defaultProps = {
    className: '',
    index: 0,
    cardsLength: 0,
    metadata: {},
  };

  getDateFromMetadata = (dateString) => {
    if (!dateString) return null;
    const date = new Date(`${dateString}T00:00:00`).toUTCString();
    return date;
  };

  getBadge = (metadata, index, cardsLength) => {
    let badgeTop = '';
    let badgeBottom = '';
    let showBadge = false;

    switch (metadata.badge) {
      case 'letters': {
        const alphabet = i18next.t('ABCDEFGHIJKLMNOPQRSTUVWXYZ');
        // hide badge if there are over alphabet length items in letters
        if (index > alphabet.length - 1) {
          showBadge = false;
          break;
        }
        badgeBottom = alphabet.charAt(index);
        showBadge = true;
        break;
      }
      case 'numbersAsc':
        badgeBottom = index + 1;
        showBadge = true;
        break;
      case 'numbersDesc':
        badgeBottom = cardsLength - index;
        showBadge = true;
        break;
      case 'dates': {
        if (!metadata.badgeDate && !metadata.badgeStartDate) {
          showBadge = false;
          break;
        }
        const badgeDate = this.getDateFromMetadata(metadata.badgeDate);
        const startDate = this.getDateFromMetadata(metadata.badgeStartDate);
        const useDate = badgeDate || startDate;
        const cardDate = addDays(useDate, (badgeDate ? 0 : index));
        badgeTop = i18next.t(AP_MONTHS[cardDate.getMonth()]);
        badgeBottom = cardDate.getUTCDate();
        if (badgeBottom.toString().length === 1) badgeBottom = `0${badgeBottom}`; // pad with 0
        showBadge = true;
        break;
      }
      default:
        showBadge = false;
        break;
    }
    return { showBadge, badgeTop, badgeBottom };
  };

  render() {
    const {
      className,
      metadata,
      index,
      cardsLength,
    } = this.props;

    const { showBadge, badgeTop, badgeBottom } = this.getBadge(metadata, index, cardsLength);

    if (!showBadge) {
      return null;
    }

    return (
      <div className={`waffle-badge ${className} pa2`}>
        <WaffleBadgeTop badgeTop={badgeTop} />
        <WaffleBadgeBottom badgeBottom={badgeBottom} />
      </div>
    );
  }
}

const WaffleBadgeTop = ({ badgeTop }) => (
  <div
    className="f5 white publico-hed waffle-badge__top"
    data-test="badge__top"
  >
    {badgeTop}
  </div>
);

WaffleBadgeTop.propTypes = {
  badgeTop: PropTypes.string.isRequired,
};


const WaffleBadgeBottom = ({ badgeBottom }) => (
  <div
    className="f9 tr white lh-none ttu waffle-badge__bottom"
    data-test="badge__bottom"
  >
    {badgeBottom}
  </div>
);

WaffleBadgeBottom.propTypes = {
  badgeBottom: PropTypes.string.isRequired,
};

export default WaffleBadge;
